export default "/etc.clientlibs/des/ploom/clientlibs/publish/des-react-hybrid/resources/3327fa6c8d602aebae9b6f98170f78ad.png";